<!--
 * Copyright (c) 2023 by Allen_sun email: Allen_sun_js@hotmail.com, All Rights Reserved.
-->
<!--
 * Copyright (c) 2023 by Allen_sun email: Allen_sun_js@hotmail.com, All Rights Reserved.
-->
<div class='structure-box pt-md'>
  <!--  搜索框-->
  <div>
    <nz-input-group class='search-input' [nzPrefix]='searchIcon' [nzSuffix]='clearIcon'>
      <input nz-input class='selfRadius' placeholder='搜索部门/人员名称' [(ngModel)]='searchKey'
        (keydown.enter)='$event.target.blur()' (blur)='search()' />
    </nz-input-group>
    <ng-template #searchIcon>
      <i nz-icon nzIconfont='icon_search' class='text-gray1' style='font-size: 14px'></i>
    </ng-template>
    <ng-template #clearIcon>
      <i nz-icon nzType='close-circle' nzTheme='outline' *ngIf="searchKey!=''" class='text-gray1 clickEle'
        (click)='clearSearch()'></i>
    </ng-template>
  </div>
  <!--  搜索框End-->
  <!--  类型tab-->
  <div class='type-tab-box mt-md' [ngClass]='{ hide: searchStatus }'>
    <radio-button [data]='typeOptions' [(check)]='checkType' (checkChange)='checkTypeChange($event)'
      [itemStyle]="{ 'margin-bottom': 0, 'min-width': '60px', padding: 0 ,flex:'auto'}"
      [checkPoint]='false'></radio-button>
  </div>
  <!--  类型tab End-->
  <div class='structure-tree mt-sm' [ngClass]='{ hide: searchStatus }'>
    <nz-tree [nzData]='showStructure' (nzClick)='checkStructure($event)' [nzTreeTemplate]='treeTpl'
      [nzSelectedKeys]='selectIds' [nzExpandedKeys]='defaultExpandedKeys' [nzCheckStrictly]='true' [nzExpandAll]='true'
      [nzVirtualHeight]="(height-104)+'px'" style='background: var(--gray-bg)'>
      <ng-template #treeTpl let-node>
        <div class='flexRow text-nowrap text-truncate '>
          <i nz-icon nzIconfont='icon_jiagou' *ngIf='node.level == 0' class='structure-icon mr-sm'></i>
          <i nz-icon nzIconfont='icon_pianqu'
            *ngIf="node.origin['organ_type']==1 && node.origin['organ_type_extra'] ==2"
            class='structure-icon mr-sm'></i>
          <i nz-icon nzIconfont='icon_arrive'
            *ngIf="node.origin['organ_type']==1 && node.origin['organ_type_extra'] ==3"
            class='structure-icon mr-sm'></i>
          <i nz-icon nzIconfont='icon_zu'
            *ngIf="(node.origin['organ_type_extra'] ==0 ||node.origin['organ_type_extra'] ==4) && node.level >0"
            class='structure-icon mr-sm'></i>
          <div class='mr-sm'>{{ node.title }}</div>
          <div class='text-gray1' [ngClass]="{'d-none':node.origin['manage_name']==''}">
            ({{ node.origin['manage_name'] }})
          </div>
        </div>
      </ng-template>
    </nz-tree>
  </div>

  <!--  检索结果显示-->
  <div class='search-result-box flexColumn' [ngClass]='{ hide: !searchStatus }' [ngStyle]="{'height':(height-64)+'px'}">
    <div class='mt-md text-md result-title all-width'>部门列表</div>
    <div class='structure-tree mt-12 border-bottom-1 all-width'>
      <nz-tree [nzData]='structure' (nzClick)='checkStructure($event)' [nzTreeTemplate]='searchTreeTpl'
        [nzSelectedKeys]='selectIds' [nzCheckStrictly]='true' [nzExpandAll]='true' nzHideUnMatched
        [nzSearchValue]='searchKey' nzVirtualMaxBufferPx='250px' nzVirtualItemSize='32px'
        style='max-height: 250px; background: var(--gray-bg)'>
        <ng-template #searchTreeTpl let-node>
          <div class='flexRow text-nowrap text-truncate
          '>
            <div class='mr-sm'>{{ node.title }}</div>
            <div class='text-gray1' *ngIf='node.level != 0'>
              ({{ node.origin['manage_name'] ? node.origin['manage_name'] : '负责人' }})
            </div>
          </div>
        </ng-template>
      </nz-tree>
    </div>
    <div class='mt-md text-md result-title mt-lg all-width'>人员列表</div>
    <div class='structure-tree employee-result mt-12 all-width flexFull'>
      <ng-container *ngFor='let type of searchEmployeeData; let index = index'>
        <div class='organ-type-box'>
          <div class='organ-type-title flexRow text-gray1'>
            <i nz-icon nzIconfont='icon_fold_triangle' class='pl-sm text-gray1 clickEle' (click)='clickFold(index)'
              *ngIf='foldIndex.indexOf(index) == -1'></i>
            <i nz-icon nzIconfont='icon_unfold_triangle' class='pl-sm text-gray1 clickEle' (click)='clickFold(index)'
              *ngIf='foldIndex.indexOf(index) > -1'></i>
            <div>{{ type.title }}</div>
          </div>
          <ng-container *ngFor="let depart of type['child_node']">
            <div class='pl-xl text-gray1 isDepart' [ngClass]='{ hide: foldIndex.indexOf(index) == -1 }'>{{
              depart['title'] }}</div>
            <ng-container *ngFor="let employee of depart['child_node']">
              <div class='pl-xl text-gray1 isEmployee clickEle flexRow'
                [ngClass]="{ hide: foldIndex.indexOf(index) == -1, 'selected-employee': checkEmployeeID == employee['employee_id'] }"
                (click)='checkEmployee(employee)'>
                <i nzIconfont='icon_user' nz-icon class='structure-icon mr-sm'></i>
                <div class='flexFull'>{{ employee['username'] }}</div>
                <div class='depart-name text-truncate d-inline-block'>{{ employee['depart_name'] }}</div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
  <!--  检索结果显示 End-->
</div>